<template>
  <div>
        <van-popup
          v-model="show"
          round
          position="bottom"
          closeable
          class="van-popup-wrapper"
          @close="closePop"
        >
          <div class='preview' :style="{background:formSet.bg_colour}">
            <div
              class='lottery-img-show'
              :style="{background: formSet.cover_image_switch==='1'?`url(${formSet.cover_image}) no-repeat scroll top center/100%`:'' }">
              <h3>{{formSet.title}}</h3>
              <p v-if="formSet.introduce_switch==='1'">{{formSet.introduce}}</p>
              <div class='form-wrapper'>
                <van-form
                  @submit="onSubmit"
                  @failed="onFailed"
                  validate-trigger="onSubmit"
                  :show-error-message="false"
                  :validate-first="true"
                  :show-error="false"
                >

                  <div class="item-list">
                    <div v-for="(item,index) in formSet.variable_inputs" :key="index"
                         class="item"
                    >
                      <van-field
                        v-if="item.name==='name'"
                        :name="item.name"
                        v-model="form.name"
                        label=""
                        :border="true"
                        :rules="[{ required: item.required===1, message: `请输入${item.title}` }]"
                        maxlength="10"
                        @input="(val)=>changeVal(val,'name')"
                        :placeholder="`请${item.type==='address_select'||item.type==='select'?'选择':'输入'}${item.title}${item.required===1?(item.type==='address_select'||item.type==='select')?'(必选)':'(必填)':''}`"
                      />
                      <van-field
                        v-if="item.name==='phone'"
                        v-model="form.phone"
                        pattern="[0-9]*"
                        onkeyup="value=value.replace(/[^\d]/g,'')"
                        type="tel"
                        maxlength="11"
                        :name="item.name"
                        label=""
                        :border="true"
                        :rules="[{ required: item.required===1, message: `请输入${item.title}` }]"
                        :placeholder="`请${item.type==='address_select'||item.type==='select'?'选择':'输入'}${item.title}${item.required===1?(item.type==='address_select'||item.type==='select')?'(必选)':'(必填)':''}`"
                      />
                      <van-field
                        v-if="item.name==='text_1'"
                        v-model="form.text_1"
                        :name="item.name"
                        label=""
                        :border="true"
                        maxlength="30"
                        @input="(val)=>changeVal(val,'text_1')"
                        :rules="[{ required: item.required===1, message: `请输入${item.title}` }]"
                        :placeholder="`请${item.type==='address_select'||item.type==='select'?'选择':'输入'}${item.title}${item.required===1?(item.type==='address_select'||item.type==='select')?'(必选)':'(必填)':''}`"
                      />
                      <van-field
                        v-if="item.type==='address_select'"
                        v-model="fieldValue"
                        :name="item.type"
                        is-link
                        readonly
                        label=""
                        :placeholder="`请选择${item.title}${item.required===1?'(必选)':''}`"
                        :rules="[{ required: item.required===1, message: `请选择${item.title}` }]"
                        @click="isShowAddress = true"
                        :border="true"
                      />
                      <van-popup
                                 v-if="item.type==='address_select'"
                                 v-model="isShowAddress"
                                 round
                                 position="bottom"
                      >
                        <!--                          :title="`${item.title}选择`"-->

                        <van-cascader
                          v-model="cascaderValue"
                          :options="options"
                          :field-names="addressFieldNames"
                          active-color="#0089FF"
                          :placeholder="['省份选择','城市选择','区县选择']"
                          @change="onChange"
                          @close="isShowAddress = false"
                          @finish="onFinish"
                        />
                      </van-popup>
                      <van-field
                        v-if="item.type==='select'"
                        v-model="form.select"
                        :name="item.name"
                        is-link
                        readonly
                        label=""
                        :placeholder="`请选择${item.title}${item.required===1?'(必选)':''}`"
                        :rules="[{ required: item.required===1, message: `请选择${item.title}` }]"
                        @click="isShowSelect = true"
                        :border="true"
                      />
                      <van-popup
                               v-if="item.type==='select'"
                                 v-model="isShowSelect"
                                 round
                                 position="bottom"
                      >
                        <van-cascader
                          :field-names="selectFieldNames"
                          :options="item.option"
                          active-color="#0089FF"
                          @close="isShowSelect = false"
                          @finish="onFinishSelect"
                          :placeholder="['请选择']"
                        />
                      </van-popup>
                    </div>

                  </div>
                    <van-button round block type="info" native-type="submit" class='btn'>{{formSet.submit}}</van-button>
                </van-form>
              </div>
            </div>
          </div>
        </van-popup>
  </div>
</template>

<script>
import XHR from '../api'
export default {
  name: 'RetainCapital',
  props: {
    setData: {
      type: Object,
      default: () => {
      }
    },
    uid: {
      type: String,
      default: '0'
    },
    phone: {
      type: String,
      default: ''
    }

  },
  data: () => ({
    show: true,
    formSet: {
    },
    submitParams: {
      name: '',
      phone: '',
      text_1: '',
      province_id: '',
      city_id: '',
      area_id: '',
      select_1: ''
    },
    isShowAddress: false,
    cascaderValue: '',
    isShowSelect: false,
    addressFieldNames: {
      text: 'name',
      value: 'sn',
      children: 'children'
    },
    options: [],
    selectOptions: [],
    selectFieldNames: {
      text: 'val',
      value: 'key'
    },
    provinceIndex: 0,
    cityIndex: 0,
    fieldValue: '',
    addressSet: null,
    form: {
      name: '',
      text_1: '',
      phone: '',
      select: ''
    },
    selectedOptions: [],
    oneSelectedOptions: [],
    isLock: false
  }),
  async created () {
    await this.getFormRenderRule()
    // eslint-disable-next-line eqeqeq
    if (this.setData.enroll_limit == 1) {
      this.form.phone = this.phone
    }
    if (this.addressSet != null) {
      await this.getAddress('province')
      // eslint-disable-next-line eqeqeq
      if (this.addressSet.auto_location == 1) {
        this.$store.dispatch('getLocation')
        if (this.locationProvince.sn) {
          const params = { provincesn: this.locationProvince.sn }
          this.cascaderValue = this.locationProvince.sn
          const provinceObj = this.options.filter((item, index) => {
            if (item.sn === this.locationProvince.sn) {
              this.provinceIndex = index
              this.selectedOptions = [{ sn: this.locationProvince.sn }]
            }
            return item.sn === this.locationProvince.sn
          })
          if (provinceObj.length) {
            this.fieldValue = provinceObj[0].name
          }
          if (parseInt(this.addressSet.accuracy) > 1) {
            await this.getAddress('city', params)
            if (this.locationCity.sn && parseInt(this.addressSet.accuracy) >= 2) {
              params.citysn = this.locationCity.sn
              this.selectedOptions = [{ sn: this.locationProvince.sn }, { sn: this.locationCity.sn }]
              await this.getAddress('area', params)
              const list = this.options[this.provinceIndex].children
              const cityObj = list.filter(item => item.sn === this.locationCity.sn)
              if (cityObj.length) {
                this.fieldValue = `${this.fieldValue}/${cityObj[0].name}`
              }
              this.cascaderValue = this.locationCity.sn
            }
          }
        }
      }
    }
  },
  methods: {
    closePop () {
      this.$emit('close')
    },
    async getFormRenderRule () {
      const params = {
        rid: this.setData.rid
      }
      await XHR.getFormRenderRule(params).then(res => {
        const { data, status } = res.data
        if (!status) {
          this.formSet = data
          const list = data.variable_inputs.filter(item => item.type === 'address_select')
          if (list.length) {
            this.addressSet = list[0]
          }
        }
      })
    },
    changeVal (val, type) {
      if (type === 'name') {
        this.form[type] = this.checkName(val)
      } else {
        this.form[type] = this.clearEmoji(val)
      }
    },
    onSubmit (value) {
      // eslint-disable-next-line eqeqeq
      if (this.setData.enroll_limit == '1' && (!this.uid || this.uid === '0')) {
        this.$emit('login')
        return false
      }
      const values = { ...value }
      // eslint-disable-next-line eqeqeq
      if (this.setData.enroll_limit == '1') {
        values.uid = this.uid
      }
      if (values.phone != null && values.phone !== '' && !this.isPhoneNumber(values.phone)) {
        const arr = this.formSet.variable_inputs.filter(item => item.name === 'phone')
        this.showErrorInfo(`请输入正确的${arr.length ? arr[0].title : '电话'}`)
        return
      }
      if (values.address_select != null && values.address_select !== '') {
        if (parseInt(this.addressSet.accuracy) > 0 && !this.selectedOptions.length) {
          this.showErrorInfo('请选择省')
          return
        } else if (parseInt(this.addressSet.accuracy) > 0 && this.selectedOptions.length) {
          values.province_id = this.selectedOptions[0].sn
        } else {
          values.province_id = ''
        }
        if (parseInt(this.addressSet.accuracy) > 1 && this.selectedOptions.length < 2) {
          this.showErrorInfo('请选择市')
          return
        } else if (parseInt(this.addressSet.accuracy) > 1 && this.selectedOptions.length > 1) {
          values.city_id = this.selectedOptions[1].sn
        } else {
          values.city_id = ''
        }
        if (parseInt(this.addressSet.accuracy) > 2 && this.selectedOptions.length < 3) {
          this.showErrorInfo('请选择区')
          return
        } else if (parseInt(this.addressSet.accuracy) > 2 && this.selectedOptions.length > 2) {
          values.area_id = this.selectedOptions[2].sn
        } else {
          values.area_id = ''
        }
      }
      if (values.select_1 != null) {
        values.select_1 = this.oneSelectedOptions[0].key
      }
      values.rid = this.setData.rid
      delete values.address_select
      delete values.timestamp
      if (this.isLock) {
        return
      }
      this.isLock = true
      XHR.formAddData(values).then(res => {
        const { status, msg } = res.data
        this.isLock = false
        if (!status) {
          // this.showErrorInfo('提交成功')
          this.$toast({
            message: '提交成功',
            type: 'success',
            duration: 2000
          })
          this.$emit('close')
        } else {
          this.showErrorInfo(msg)
        }
      })
    },
    onFailed ({ errors }) {
      const msg = errors[0].message
      this.showErrorInfo(msg)
    },
    onFinishSelect ({ selectedOptions, tabIndex }) {
      this.isShowSelect = false
      this.form.select = selectedOptions.map((option) => option.val)
      this.oneSelectedOptions = selectedOptions
    },
    onFinish ({ selectedOptions, tabIndex }) {
      if (this.addressSet != null && (parseInt(this.addressSet.accuracy) - 1 === tabIndex)) {
        this.selectedOptions = selectedOptions
        this.isShowAddress = false
        this.fieldValue = selectedOptions.map((option) => option.name).join('/')
      }
    },
    // 获取省列表
    async  getAddress (type, params = {}) {
      await XHR.getAddress(params).then(res => {
        const { data, status } = res.data
        if (!status) {
          if (type === 'province') {
            this.options = data
          } else if (type === 'city') {
            for (let i = 0; i < this.options.length; i++) {
              if (this.options[i].sn === params.provincesn) {
                // setTimeout(() => {
                const options = [...this.options]
                options[i].children = data
                this.options = options
                this.provinceIndex = i
                // }, 500)
                break
              }
            }
          } else {
            const list = this.options[this.provinceIndex].children
            for (let i = 0; i < list.length; i++) {
              if (list[i].sn === params.citysn) {
                const options = [...this.options]
                options[this.provinceIndex].children[i].children = data
                this.options = options
                break
              }
            }
          }
        }
      })
    },
    onChange (e) {
      const { tabIndex, selectedOptions } = e
      const params = { provincesn: selectedOptions[0].sn }
      if (tabIndex === 0 && this.addressSet != null && parseInt(this.addressSet.accuracy) > 1) {
        this.getAddress('city', params)
      } else if (tabIndex === 1 && this.addressSet != null && parseInt(this.addressSet.accuracy) > 2) {
        params.citysn = selectedOptions[1].sn
        this.getAddress('area', params)
      }
    }
  }
}
</script>

<style scoped lang="less">
  .van-popup-wrapper{
    .preview {
      position: relative;
      width:100%;
      .lottery-img-show {
        box-sizing: border-box;
        padding: 15px 12px 8px;
        background-size: 100%;
      }
      h3 {
        font-size: 18px;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 25px;
        text-align: center;
      }
      p {
        margin-top: 19px;
        font-size: 15px;
        line-height: 21px;
        color: #FFFFFF;
      }

      .form-wrapper {
        position: relative;
        width: 352px;
        margin-top: 22px;
        box-sizing: border-box;
        .item-list{
          height: 302px;
          padding: 20px 12px 4px;
          box-sizing: border-box;
          background: #FFFFFF;
          border-radius: 11px 11px 0 0;
        }
        .van-field{
          border-radius: 5px;
          border: 1px solid rgba(23, 24, 26, 0.08);
          margin-bottom: 12px;
        }
        .item:nth-last-of-type(1){
          .van-field{
            margin-bottom: 0;
          }
        }
        .btn {
          display: block;
          width: 327px;
          height: 53px;
          margin: 8px auto 0;
          background: #FFD12E;
          border-radius: 24px;
          line-height: 53px;
          text-align: center;
          font-size: 22px;
          font-weight: bold;
          color: #A51606;
          border:none;
        }
      }
    }
  }
 /deep/ .van-cascader{
   .van-cascader__tabs.van-tabs--line .van-tabs__wrap{
     border-bottom:1px solid rgba(23, 24, 26, 0.08);
   }
   .van-tabs__line{
     width: 31px;
     height: 4px;
     background: #0089FF;
     border-radius: 2px;
   }
   .van-tab--active{
     color: rgba(23, 24, 26, 0.8) !important;
     font-weight: bolder!important;
   }
   .van-cascader__tab{
     color: rgba(23, 24, 26, 0.7);
   }
   .van-tab{
     /*height:55px;*/
   }
   .van-cascader__option{
     color:rgba(23, 24, 26, 0.7);
     span{
       overflow: hidden;
       text-overflow: ellipsis;
       white-space: nowrap;
     }
   }
   .van-cascader__header{
     height:8px;
   }
   .van-cascader__close-icon{
     position: absolute;
     color: #18191B;
     font-size: 14px;
     right: 16px;
     top: 15px;
     z-index: 100;
   }
 }
  /deep/ .van-cell__right-icon{
    color: rgba(23, 24, 26, 0.4);
  }
 /deep/ input::-webkit-input-placeholder {
    color: rgba(23, 24, 26, 0.5);
  }
  /deep/ input{
    transform: translate3d(0,0,0);
  }
</style>
